<mat-card class="summary-card" [class.compact]="compact">
  <h3>Zusammenfassung</h3>

  <div class="summary-grid">
    <div class="summary-row">
      <span class="label">Terminart</span>
      <span class="value">{{ preselection?.appointmentType?.title || '—' }}</span>
    </div>
    <div class="summary-row">
      <span class="label">Datum</span>
      <span class="value">{{ day?.displayDate || '—' }}</span>
    </div>
    <div class="summary-row">
      <span class="label">Uhrzeit</span>
      <span class="value">{{ slot?.displayTime || '—' }}</span>
    </div>
    <div class="summary-row">
      <span class="label">Versicherung</span>
      <span class="value">{{ preselection?.insurance?.label || '—' }}</span>
    </div>
    <div class="summary-row">
      <span class="label">Patientenstatus</span>
      <span class="value">{{ preselection?.patientStatus?.label || '—' }}</span>
    </div>
  </div>
</mat-card>
